import React, { Component } from "react";
import Select from "react-select";
import { getCustomStyles } from "../../../../data/themes";
import { scrollIntoView } from "../../../util/util-vanilla";
import { classNames } from "../../../util/util-helpers";
import {LoaderSmall} from "../../loader";
import Tooltip from "../../tooltip";

export default class FieldDropdownSelect extends Component {

    state = {
        isLoading: false,
        currentOptions: [],
        defaultOptions: [],
        hintMessage: "",
    };

    debounceTimeout = null;
    hintTimeout = null;

    componentWillUnmount() {
        clearTimeout(this.debounceTimeout);
        clearTimeout(this.hintTimeout);
    }

    handleInputChange = (inputValue) => {
        if (!this.props.loadOptions) return;

        clearTimeout(this.debounceTimeout);
        clearTimeout(this.hintTimeout);
        this.setState({hintMessage: ""});

        const len = inputValue?.length ?? 0;

        if (len === 0) {
            this.setState({currentOptions: this.state.defaultOptions, isLoading: false});
            return;
        }

        if (len < 3) {
            this.setState({currentOptions: [], isLoading: false});
            this.hintTimeout = setTimeout(
                () => this.setState({hintMessage: "Type at least 3 characters to search"}),
                2000
            );
            return;
        }

        this.setState({isLoading: true});
        this.debounceTimeout = setTimeout(() => {
            this.props.loadOptions(inputValue, (options) => {
                this.setState({isLoading: false, currentOptions: options ?? []});
            });
        }, 500);
    };

    render() {
        const pairs = this.props.values ? this.props.values : {};

        const tooltipPlacement = this.props.menuPlacement === "top" ? "bottom-start" : "top-start";

        return (
            <React.Fragment>
                <Tooltip
                    content="Type at least 3 characters to search"
                    visible={!!this.state.hintMessage}
                    disabled={!this.state.hintMessage}
                    trigger="manual"
                    placement={tooltipPlacement}
                >
                <div>
                <Select
                    autoFocus={this.props.autoFocus}
                    ref={this.props.innerRef}
                    styles={this.props.inputStyles ?? getCustomStyles()}
                    className={
                        classNames(
                            "select-css-search p-0 relative",
                            this.props.addClass ? this.props.addClass : undefined,
                        this.props.errorMessage ? "is-invalid" : undefined
                        )
                    }
                    onKeyDown={this.props.onKeyDown}
                    isDisabled={!!this.props.disabled}
                    onChange={(selectedOption) => {
                        this.props.onChange(this.props.name, selectedOption);
                    }}
                    name={this.props.name}
                    value={!this.props.loadOptions ? (this.props.value ? {
                        value: this.props.value,
                        label: pairs[this.props.value]
                    } : null) : this.props.value}
                    options={this.props.loadOptions ? this.state.currentOptions : this.props.options}
                    filterOption={this.props.loadOptions ? () => true : undefined}
                    onInputChange={this.props.loadOptions ? this.handleInputChange : undefined}
                    isClearable={!!this.props.isClearable}
                    isMulti={this.props.multi}
                    placeholder={this.props.placeholder ? this.props.placeholder : "Type to search..."}
                    onFocus={(event) => {
                        if (this.props.onFocus) {
                            this.props.onFocus(event);
                        }

                        if (this.props.loadOptions && !this.state.defaultOptions?.length) {
                            this.setState({isLoading: true});
                            this.props.loadOptions('', (options) => {
                                if (options) {
                                    this.setState({isLoading: false, defaultOptions: options, currentOptions: options});
                                }
                            });
                        }

                        scrollIntoView(event);
                    }}
                    onBlur={(event) => {
                        this.setState({hintMessage: ""});
                        if (this.props.onBlur) {
                            this.props.onBlur(event);
                        }
                    }}
                    key={this.props.key}
                    openMenuOnFocus={this.props.openMenuOnFocus}
                    menuPlacement={this.props.menuPlacement}
                    menuPortalTarget={this.props.hasPortal ? document.body : null}
                    isLoading={this.state.isLoading}
                    loadingMessage={() => 'Searching...'}
                />
                </div>
                </Tooltip>

                {this.props.errorMessage && (
                    <div className={"text-red-600 font-semibold"}>
                        {!!this.props.translate && (
                            this.props.errorMessage.reduce((memo, it) => {
                                return this.props.translate(it) + (memo ? "," + memo : "")
                            }, "")
                        )}
                        {!this.props.translate && (
                            <span>Field required*</span>
                        )}
                    </div>
                )}

                {this.props.isLoading && (
                    <LoaderSmall addClass={"absolute right-12 top-1/2"}/>
                )}
            </React.Fragment>
        )
    }
}
